import React from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from "react-query";
import { MainContainer, MainTitle, TitleContainer, ColumnContainer, Column, SimpleLink } from '@beacharound/beacharound-ui';

import { getBeaches } from '../../api/beach';

export default function BeachesSitemap() {

    let options = {
        params: {
            type: 'private'
        },
        skip: 0,
        limit: 2000000,
        sort: {name: 1}
    }

    const { data } = useQuery(["beaches", options], () =>
        getBeaches({params: options})
    )

    return (
        <MainContainer>
            <TitleContainer>
                <MainTitle text="Mappa del sito - Spiagge" component="div" />
            </TitleContainer>

             <ColumnContainer flex>
                {data?.map((sitemap, index) => {
                    return (
                        <Column column={2} key={index}>
                            <SimpleLink index={sitemap.slug} text={sitemap.name} to={`/spiagge/${sitemap.slug}`} component={Link} />
                        </Column>
                    )
                })}
            </ColumnContainer>
        </MainContainer>
    );
}